import { defineStore } from 'pinia'
import axios from 'axios'
import { formatDate } from '../utils/datetime'

export const useUserStore = defineStore('user', {
  state: () => ({
    id: null as number | null,
    firstName: '',
    lastName: '',
    email: '',
    createdAt: '',
    role: '' as string,
    permissions: [] as string[],
    is2FAEnabled: false,
  }),

  getters: {
    userName: (state) => `${state.firstName} ${state.lastName}`.trim(),
    memberSince: (state) => (state.createdAt ? formatDate(state.createdAt) : ''),
    hasPermission: (state) => (permission: string) => state.role === 'Admin' || state.permissions.includes(permission),
  },

  actions: {
    async fetchMe() {
      const { data } = await axios.get('/api/auth/me')
      this.id = data.id
      this.firstName = data.firstName
      this.lastName = data.lastName
      this.email = data.email
      this.createdAt = data.createdAt
      this.role = data.role ?? ''
      this.permissions = data.permissions ?? []
    },

    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },

    changeUserName(userName: string) {
      const parts = userName.trim().split(' ')
      this.firstName = parts[0] ?? ''
      this.lastName = parts.slice(1).join(' ')
    },
  },
})
